import { TFunction } from 'i18next'
import { ComponentType } from 'react'

import { IntercomDE, IntercomDK, IntercomFR, IntercomNL } from '../../../../../../../../assets/images'

interface IntercomWidgetConfigs {
  availabilityText: string
  waitingTimeText?: string
  Icon: ComponentType<{ className?: string }>
}

export const getIntercomWidgetMarketConfigs = (t: TFunction, countryId: string): IntercomWidgetConfigs => {
  const defaultIntercomWidgetConfigs: IntercomWidgetConfigs = {
    availabilityText: t('help.modal.chat.availability.dk'),
    waitingTimeText: t('help.modal.chat.response_time', { period: t('minutes_count', { count: 3 }) }),
    Icon: IntercomDK,
  }
  return (
    {
      DK: defaultIntercomWidgetConfigs,
      FR: {
        availabilityText: t('help.modal.chat.availability.fr'),
        Icon: IntercomFR,
      },
      NL: {
        availabilityText: t('help.modal.chat.availability.nl'),
        waitingTimeText: t('help.modal.chat.response_time', { period: t('days_count', { count: 1 }) }),
        Icon: IntercomNL,
      },
      DE: {
        availabilityText: t('help.modal.chat.availability.de'),
        waitingTimeText: t('help.modal.chat.response_time', { period: t('hours_count', { count: 1 }) }),
        Icon: IntercomDE,
      },
    }[countryId] || defaultIntercomWidgetConfigs
  )
}
